import script from "./ChatContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatContainer.vue?vue&type=script&setup=true&lang=js"

import "./ChatContainer.vue?vue&type=style&index=0&id=e3be77b0&lang=scss&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3be77b0"]])

export default __exports__